import { api } from '@/shared/axios-client';

export const EMPTY_CONTENT_HASH =
  'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';

export function isEmptyContentHash(hash: string | null | undefined): boolean {
  return (hash ?? '').trim() === EMPTY_CONTENT_HASH;
}

export type HashCheckFileDelta = {
  filePath?: string;
  fileName?: string;
  contentHash?: string;
  oldHash?: string;
  newHash?: string;
  /** True when DB had empty hash from a prior failed fetch and was repaired. */
  recoveredFromEmptyHash?: boolean;
};

export type HashCheckFetchFailed = {
  filePath?: string;
  fileName?: string;
  reason?: string;
  attempts?: number;
};

export type HashCheckSummary = {
  unchanged?: number;
  changed?: number;
  added?: number;
  removed?: number;
  restored?: number;
  fetchFailed?: number;
  skipped?: number;
  updatedInDb?: number;
  insertedInDb?: number;
  remoteTotal?: number;
  dbTotalAfter?: number;
};

export type TestScriptHashCheckData = {
  repositoryId?: string;
  repoName?: string;
  inventoryId?: string;
  /** True when commit unchanged — no ADO re-hash performed */
  hashCheckSkipped?: boolean;
  skipReason?: string;
  resolvedBuildId?: number | string | null;
  resolvedCommitId?: string | null;
  storedCommitId?: string | null;
  versionRef?: string;
  buildResolved?: boolean;
  adoFilesListed?: number;
  candidatesProcessed?: number;
  hashedSuccessfully?: number;
  fetchErrors?: number;
  fetchExceptions?: number;
  summary?: HashCheckSummary;
  changed?: HashCheckFileDelta[];
  added?: HashCheckFileDelta[];
  removed?: HashCheckFileDelta[];
  fetchFailed?: HashCheckFetchFailed[];
  /** Per-file skip rows from sync (empty hash / fetch failure) */
  skipped?: HashCheckFileDelta[];
  error?: string;
  message?: string;
};

export interface TestScriptHashCheckServiceResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: TestScriptHashCheckData | null;
}

/**
 * Re-fetch test scripts from ADO, diff hashes vs scriptsFiles, sync DB.
 * PAT: Requester-Token header (test repo PAT preferred; falls back to stored testAutomation.testPat).
 */
export async function postTestScriptHashCheck(
  repositoryMongoId: string,
  patToken: string,
  options?: { force?: boolean},
): Promise<TestScriptHashCheckServiceResponse> {
  const params = options?.force ? { force: 'true' } : undefined;
  const res = (await api.post(
    `/api/repositories/${encodeURIComponent(repositoryMongoId)}/test-scripts/hash-check`,
    {},
    {
      params,
      headers: {
        'Requester-Token': patToken.trim(),
      },
    },
  )) as TestScriptHashCheckServiceResponse;
  return res;
}



